import { render, staticRenderFns } from "./LecturerAddLayer.vue?vue&type=template&id=3b25515f&scoped=true&"
import script from "./LecturerAddLayer.vue?vue&type=script&lang=js&"
export * from "./LecturerAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./LecturerAddLayer.vue?vue&type=style&index=0&id=3b25515f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b25515f",
  null
  
)

export default component.exports